import { ReactComponent as Facebook } from '@public/images/social/facebook.svg';
import { ReactComponent as FacebookRounded } from '@public/images/social/facebook-rounded.svg';
import styled from 'styled-components';
import Button from '@ui/atoms/Button';
import { FormattedMessage } from 'react-intl';
import UiKitTooltip from '@ui/atoms/UiKitTooltip';
import { isLoginProviderEnabled } from '@/helpers/providers';
import { LOGIN_PROVIDER } from '@/utils/constants';

const CustomButton = styled(Button)`
    width: 100%;
    color: var(--black);
    background: var(--white);
    box-shadow: none;
    transition: all 350ms;
    border: 1px solid var(--neutral200);

    &:hover {
        background: var(--neutral100);
    }

    & path {
        fill: var(--facebook);
    }

    & svg {
        width: 1rem;
        height: auto;
    }
`;

const ButtonInner = styled.div`
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
`;

const Tooltip = styled(UiKitTooltip)`
    width: auto;
`;

function FacebookButton({ rounded = false, label, ...props }) {
    return (
        <Tooltip
            variant="dark"
            passthrough={isLoginProviderEnabled(LOGIN_PROVIDER.FACEBOOK)}
            position="top"
            content={
                <FormattedMessage defaultMessage="Oups, la connexion via Facebook est actuellement indisponible. Nos équipes font le nécessaire pour réparer cela au plus vite. 💪" />
            }
        >
            <CustomButton
                isDisabled={!isLoginProviderEnabled(LOGIN_PROVIDER.FACEBOOK)}
                onPress={() => props.onPress()}
            >
                <ButtonInner>
                    {rounded ? <FacebookRounded /> : <Facebook />}
                    {label || 'Facebook'}
                </ButtonInner>
            </CustomButton>
        </Tooltip>
    );
}

export default FacebookButton;
